module.exports = __webpack_public_path__ + "img/529.203fffed.png";